exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.title-praticas[data-v-0b533cc6]{font-size:16px;font-weight:600;color:#454646\n}\n.descricao-pratica[data-v-0b533cc6]{display:-webkit-box;display:-ms-flexbox;display:flex;text-align:justify\n}\n.descricao-pratica[data-v-0b533cc6] p{font-size:14px\n}\n", "", {"version":3,"sources":["/app/src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/style.scss"],"names":[],"mappings":";AAAA,iCACE,eACA,gBACA,aAAc;CACf;AAAA,oCAGC,oBAAA,oBAAA,aACA,kBAAmB;CAFrB;AAAA,sCAII,cAAe;CAChB","file":"FP.vue","sourcesContent":[".title-praticas {\n  font-size: 16px;\n  font-weight: 600;\n  color: #454646;\n}\n\n.descricao-pratica {\n  display: flex;\n  text-align: justify;\n  /deep/ p {\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b533cc6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/FP/FP.vue
// module id = SOUL
// module chunks = 5